import { IWindowService } from "angular";

/**
 * An abstraction over the browser storage API that allows keys to
 * be localized to a specific instance of the site (eg, training)
 */
export class InstanceDb {
    localStorage: Omit<Storage, "length" | "key">;
    sessionStorage: Omit<Storage, "length" | "key">;

    constructor(apexInstancePrefix: string, $window: IWindowService) {
        'ngInject';
        this.localStorage = new InstancedStorage(apexInstancePrefix, $window.localStorage);
        this.sessionStorage = new InstancedStorage(apexInstancePrefix, $window.sessionStorage);
    }
}

class InstancedStorage implements Omit<Storage, "length" | "key"> {
    constructor(private prefix: string, private storage: Storage) {
    }

    clear(): void {
        for (let i = 0; i < this.storage.length; i++) {
            const key = this.storage.key(i);

            if (key.startsWith(this.prefix)) {
                this.storage.removeItem(key);
            }
        }
    }
    getItem(key: string): string {
        return this.storage.getItem(this.prefix + key);
    }
    removeItem(key: string): void {
        this.storage.removeItem(this.prefix + key);
    }
    setItem(key: string, value: string): void {
        this.storage.setItem(this.prefix + key, value);
    }

}
